export enum Direction {
  ASC = 'ASC',
  DESC = 'DESC',
}

export const Unlimited = 10000;
